module.exports = __webpack_public_path__ + "static/media/assistant.62c1193a.svg";